import React, { memo, useEffect } from 'react';
import { useHistory, useParams } from 'react-router';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';

import { actions, selectors } from 'src/store';
import { gameKeys, paths } from 'src/constants';
import Container from 'src/components/pages/Activities/WheelOfFortune/Levels/Container';

const TIMEOUT_DURATION = 500;

const WheelOfFortuneLevels = ({
  getLevelsByCollectionId,
  hasLoaded,
  unlockCollection,
  updateFeedback,
  currency,
  levels,
}) => {
  const history = useHistory();
  const gameKey = gameKeys.WHEEL_OF_FORTUNE;
  const { groupKey, collectionId } = useParams();

  useEffect(() => {
    getLevelsByCollectionId(collectionId);
  }, [getLevelsByCollectionId, collectionId]);

  const handleLevelAnswer = (levelId, isCorrect, currencyId) => {
    updateFeedback({ currencyId, gameKey, levelId, isCorrect });
  };

  const handleCollectionEnd = () => {
    unlockCollection({
      gameKey,
      collectionId,
    });
    setTimeout(() => {
      history.push(paths.build(paths.WHEEL_OF_FORTUNE, groupKey));
    }, TIMEOUT_DURATION);
  };

  return (
    <Container
      currency={currency}
      handleCollectionEnd={handleCollectionEnd}
      handleLevelAnswer={handleLevelAnswer}
      hasLoaded={hasLoaded}
      items={levels}
    />
  );
};

WheelOfFortuneLevels.propTypes = {
  getLevelsByCollectionId: PropTypes.func.isRequired,
  hasLoaded: PropTypes.bool.isRequired,
  unlockCollection: PropTypes.func.isRequired,
  updateFeedback: PropTypes.func.isRequired,
  currency: PropTypes.shape({
    id: PropTypes.number,
  }).isRequired,
  levels: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

const mapStateToProps = (state) => ({
  hasLoaded: selectors.wheelOfFortuneLevels.getHasLoaded(state),
  currency: selectors.wheelOfFortuneLevels.getCurrencyData(state),
  levels: selectors.wheelOfFortuneLevels.getLevelsData(state),
});

const mapDispatchToProps = {
  ...actions.wheelOfFortune,
  ...actions.feedback,
  ...actions.students,
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  memo
)(WheelOfFortuneLevels);
